module.exports = __webpack_public_path__ + "img/moon_covered_by_clouds.f8a94a4b.jpg";